import { render, staticRenderFns } from "./ImportsLeaseCharges.vue?vue&type=template&id=c85bbc1e"
import script from "./ImportsLeaseCharges.vue?vue&type=script&lang=js"
export * from "./ImportsLeaseCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports